module.exports = __webpack_public_path__ + "img/thsr-train-2.f8859178.jpg";